import { execute, builtObjectDict, outPutResult } from "./code-segment.js";

var InterfaceTypeEnum = { Catalog: 0, Interface: 1 };
//获取接口字典
var getInterfaceDict = function(interfaces) {
  let dic = {};
  interfaces.forEach(item => {
    if (item.type == InterfaceTypeEnum.Interface) {
      dic[item.name] = item;
    } else if (item.type == InterfaceTypeEnum.Catalog) {
      dic = Object.assign(dic, getInterfaceDict(item.children));
    }
  });
  return dic;
};

//接口运行
var runInterface = async function(
  interfaceDict,
  interfaceName,
  parameters,
  dataSourceType,
  tableData
) {
  var interfaceItem = interfaceDict[interfaceName]; //找出接口代码块
  var options = builtObjectDict(
    interfaceItem.variables,
    parameters,
    dataSourceType
  );
  options.tableData = tableData;
  await execute(interfaceItem.content, options);
  return outPutResult(options);
};

export { runInterface, getInterfaceDict };
